const BENEFICIARIES_LOADED = "BENEFICIARIES_LOADED";
const CLEAR_PANEL = "CLEAR_PANEL";
const ADD_CREDENTIAL_SVG = 'ADD_CREDENTIAL_SVG';
const ADD_RECEIPT_PAYMENT_SVG = 'ADD_RECEIPT_PAYMENT_SVG';

export {
  BENEFICIARIES_LOADED,
  CLEAR_PANEL,
  ADD_CREDENTIAL_SVG,
  ADD_RECEIPT_PAYMENT_SVG
};

function setBeneficiariesLoaded() {
  return {
    type: BENEFICIARIES_LOADED,
    panel: {
      beneficiariesLoaded: true,
    }
  }
}

function clearPanel() {
  return {
    type: CLEAR_PANEL,
    panel: {}
  }
}

function addCredentialSVG(credential) {
  return {
    type: ADD_CREDENTIAL_SVG,
    credential,
  }
}

function addReceiptPaymentSVG(receipt) {
  return {
    type: ADD_RECEIPT_PAYMENT_SVG,
    receipt,
  }
}

export {
  setBeneficiariesLoaded,
  clearPanel,
  addCredentialSVG,
  addReceiptPaymentSVG
}

